import React from "react";
import "./newlyweds-component.css";
import { useTranslation } from "react-i18next";

export default function NewlywedsComponent() {
  const { t } = useTranslation("newlyweds");
  return (
    <div className="newlyweds-component">
      <div className="nc_column">
        <h1 className="slide-in from-left">{t("nwcTitle")}</h1>
        <div className="nc_text">
          <h3 className="slide-in from-left">{t("nwcItem1")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem2")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem3")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem4")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem5")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem6")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem7")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem8")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem9")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem10")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem11")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem12")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem13")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem14")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem15")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem16")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem17")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem18")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem19")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem20")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem21")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem22")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem23")}</h3>
          <h3 className="slide-in from-left">{t("nwcItem24")}</h3>
        </div>
      </div>
      <div className="nc_column">
        <h1 className="slide-in from-left">{t("nwcTitle2")}</h1>
        <div className="nc_text">
          <h3 className="slide-in from-left">{t("nwcNap1")}</h3>
          <h3 className="slide-in from-left">{t("nwcNap2")}</h3>
          <h3 className="slide-in from-left">{t("nwcNap4")}</h3>
          <h3 className="slide-in from-left">{t("nwcNap5")}</h3>
          <h3 className="slide-in from-left">{t("nwcNap6")}</h3>
        </div>
      </div>
    </div>
  );
}
